import { defineStore } from "pinia";
import supplies from "../service/supplies";
import utils from '../service/utils';

const supplyStore = defineStore("supply", {
  // arrow function recommended for full type inference
  state: () => {
    return {
      supplies: [],
      selectedSupply: {},
      sortAscending: false,
      fertilizer: [],
      fertilizerAndPhytosanitary: [],
      phytosanitary: [],
      seed: [],
      gasoil: [],
      additive: [],
      page: 1,
      numberOfPages: 0,
      loading: false,
      supplyToBeCloned: {},
    };
  },
  actions: {
    selectSupplyToBeCloned(supply) {
      this.supplyToBeCloned = supply;
    },
    sortSupplies(key, type) {
      this.sortAscending = !this.sortAscending;
      let clone = this.assignDataToClone(type);

      if (key === "name" || key === "provider" || key === "format" || key === "description") {
        clone.sort(utils.alphabeticSorting(key, this.sortAscending));
      } else if (key === "totalPerUnit" || key === "pricePerFormat" || key === "pricePerPresentation") {
        clone.sort(utils.numericalSorting(key, this.sortAscending));
      }

      this.assignCloneToData(type, clone);
    },
    async getAllSupplies() {
      try {
        this.resetSuppliesData();
        const res = await supplies.getSupplies();
        this.supplies = res;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async getSupplies(type, q) {
      try {
        this.loading = true;
        this.resetSuppliesData();
        this.resetPaginationData();
        const res = await supplies.getSupplies(this.page, q, type);
        this.numberOfPages = res.numberOfPages;
        this.assignState(type, res.supplies);
        this.loading = false;
        return res.supplies;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    goToNextPage(type) {
      this.page = this.page + 1;
      this.getSupplies(type);
    },
    goToPreviousPage(type) {
      if (this.page) {
        this.page = this.page - 1;
        this.getSupplies(type);
      }
    },
    resetPaginationData() {
      this.numberOfPages = 0;
      this.page = 1;
    },
    resetSuppliesData() {
      this.supplies = [];
      this.fertilizer = [];
      this.fertilizerAndPhytosanitary = [];
      this.phytosanitary = [];
      this.seed = [];
      this.gasoil = [];
      this.additive = [];
    },
    assignState(type, supplies) {
      switch (type) {
        case "gasoil":
          this.gasoil = supplies;
          break;
        case "fertilizer":
          this.fertilizer = supplies;
          break;
        case "phytosanitary":
          this.phytosanitary = supplies;
          break;
        case "fertilizerAndPhytosanitary":
          this.fertilizerAndPhytosanitary = supplies;
          break;
        case "seed":
          this.seed = supplies;
          break;
        default:
          this.additive = supplies;
      }
    },
    assignDataToClone(type) {
      let clone = [];
      switch (type) {
        case "gasoil":
          clone = [...this.gasoil];
          break;
        case "fertilizer":
          clone = [...this.fertilizer];
          break;
        case "phytosanitary":
          clone = [...this.phytosanitary];
          break;
        case "fertilizerAndPhytosanitary":
          clone = [...this.fertilizerAndPhytosanitary];
          break;
        case "seed":
          clone = [...this.seed];
          break;
        default:
          clone = [...this.additive];
      }
      return clone;
    },
    assignCloneToData(type, array) {
      switch (type) {
        case "gasoil":
          this.gasoil = [...array];
          break;
        case "fertilizer":
          this.fertilizer = [...array];
          break;
        case "phytosanitary":
          this.phytosanitary = [...array];
          break;
        case "fertilizerAndPhytosanitary":
          this.fertilizerAndPhytosanitary = [...array];
          break;
        case "seed":
          this.seed = [...array];
          break;
        default:
          this.additive = [...array];
      }
    },
    async getSuppliesById(id) {
      try {
        const res = await supplies.getSuppliesById(id);
        this.selectedSupply = res.result;
        return res.result;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async createSupply(supply) {
      try {
        const res = await supplies.createSupply(supply);
        this.supplies = [...this.supplies, res.result];
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async removeSupply(id, type) {
      try {
        const res = await supplies.removeSupply(id);
        this.getSupplies(type);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updateSupply(id, supply) {
      try {
        const res = await supplies.updateSupply(id, supply);
        // this.getSupplies(type)
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
});

export default supplyStore;
